import React from 'react';
import { Wrapper, Title, Icon } from './styles';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons'
import { useHistory } from 'react-router-dom';

interface IText{
    text:string
}

function GoBackPage({ text }:IText){

    const history= useHistory();

    const handler = () =>{
        history.goBack()
    } 

    return(
        <Wrapper onClick={handler}>
            <Icon>
                <FontAwesomeIcon style={{height:28,width:28}} icon={faChevronLeft} />
            </Icon> 
            <Title>
                {text}
            </Title>
        </Wrapper>
    )
}

export default GoBackPage;